import { useTranslation } from 'react-i18next';

export const loading = 'ROUTE_MONITORING.LOADING';
export const details = 'ROUTE_MONITORING.DETAILS';
export const timeline = 'ROUTE_MONITORING.TIMELINE';
export const map = 'ROUTE_MONITORING.MAP';

export const driver = 'ROUTE_MONITORING.DETAILED_TABLE.ASSIGNED_DRIVER';
export const vehicle = 'ROUTE_MONITORING.DETAILED_TABLE.VEHICLE_NAME';
export const trailer = 'ROUTE_MONITORING.DETAILED_TABLE.TRAILER_NAME';
export const startedAt = 'ROUTE_MONITORING.DETAILED_TABLE.START_TIME';
export const endedAt = 'ROUTE_MONITORING.DETAILED_TABLE.END_TIME';
export const leaveBy = 'ROUTE_MONITORING.DETAILED_TABLE.LEAVE_BY';
export const etaToBase = 'ROUTE_MONITORING.DETAILED_TABLE.ETA_TO_BASE';
export const ordersCount = 'ROUTE_MONITORING.DETAILED_TABLE.NUMBER_OF_ORDERS';
export const totalCost = 'ROUTE_MONITORING.DETAILED_TABLE.TOTAL_COST';
export const totalWeight = 'ROUTE_MONITORING.DETAILED_TABLE.TOTAL_WEIGHT';
export const loadedWeight = 'ROUTE_MONITORING.DETAILED_TABLE.LOADED_WEIGHT';
export const expectedWeight = 'ROUTE_MONITORING.DETAILED_TABLE.EXPECTED_WEIGHT';
export const expected = 'ROUTE_MONITORING.DETAILED_TABLE.EXPECTED';
export const loaded = 'ROUTE_MONITORING.DETAILED_TABLE.LOADED';

export const columnButton = 'ROUTE_MONITORING.DETAILED_TABLE.CONFIG.BUTTON';

export const fulfillment = 'ROUTE_MONITORING.DETAILED_TABLE.FULFILLMENT.TITLE';
export const driverUnassigned = 'ROUTE_MONITORING.DETAILED_TABLE.ASSIGN_DRIVER.UNASSIGNED';
export const vehicleUnassigned = 'ROUTE_MONITORING.DETAILED_TABLE.ASSIGN_VEHICLE.UNASSIGNED';
export const completed = 'ROUTE_MONITORING.DETAILED_TABLE.FULFILLMENT.TOOLTIP.COMPLETED';
export const partialCompleted = 'ROUTE_MONITORING.DETAILED_TABLE.FULFILLMENT.TOOLTIP.PARTIAL';
export const canceled = 'ROUTE_MONITORING.DETAILED_TABLE.FULFILLMENT.TOOLTIP.CANCELED';
export const remain = 'ROUTE_MONITORING.DETAILED_TABLE.FULFILLMENT.TOOLTIP.REMAIN';

export const online = 'ROUTE_MONITORING.TOOLTIP.DRIVER.ONLINE';
export const offline = 'ROUTE_MONITORING.TOOLTIP.DRIVER.OFFLINE';
export const unavailable = 'ROUTE_MONITORING.TOOLTIP.DRIVER.UNAVAILABLE';
export const name = 'ROUTE_MONITORING.TOOLTIP.DRIVER.NAME';
export const onABreak = 'ROUTE_MONITORING.TOOLTIP.DRIVER.ON_A_BREAK';
export const status = 'ROUTE_MONITORING.TOOLTIP.STATUS';

export const documentationLink = 'ROUTE_MONITORING.TOOLTIP.DOCUMENTATION';
export const filters = 'ROUTE_MONITORING.FILTERS';
export const goToOrderExplorer = 'ROUTE_MONITORING.GO_TO_ORDER_DETAILS';

export const mapTooglePath = 'ROUTE_MONITORING.MAP_TOGGLE_BTN.PATH';
export const mapToogleDriverLocation = 'ROUTE_MONITORING.MAP_TOGGLE_BTN.DRIVER_LOCATION';

export const invalidRoute = 'ROUTE_MONITORING.TOOLTIP.INVALID_ROUTE';
export const invalidCalculation = 'ROUTE_MONITORING.TOOLTIP.INVALID_CALCULATION';

export const noRoute = 'ORDER_DETAILS.GROUPING.NO_ROUTE';

export const detailsHeaders = {
	driver,
	vehicle,
	trailer,
	fulfillment,
	startedAt,
	endedAt,
	leaveBy,
	etaToBase,
	ordersCount,
	totalCost,
	totalWeight,
	loadedWeight,
	expectedWeight,
	expected,
	loaded
};

const useRoutesMonitoringTranslations = () => {
	const { t } = useTranslation();

	return {
		loading: t(loading),
		details: t(details),
		timeline: t(timeline),
		map: t(map),
		completed: t(completed),
		partialCompleted: t(partialCompleted),
		canceled: t(canceled),
		remain: t(remain),
		online: t(online),
		offline: t(offline),
		unavailable: t(unavailable),
		name: t(name),
		status: t(status),
		onABreak: t(onABreak),
		documentationLink: t(documentationLink),
		driverUnassigned: t(driverUnassigned),
		vehicleUnassigned: t(vehicleUnassigned),
		columnButton: t(columnButton),
		filters: t(filters),
		goToOrderExplorer: t(goToOrderExplorer),
		mapTooglePath: t(mapTooglePath),
		mapToogleDriverLocation: t(mapToogleDriverLocation),
		invalidRoute: t(invalidRoute),
		invalidCalculation: t(invalidCalculation),
		noRoute: t(noRoute)
	};
};

export default useRoutesMonitoringTranslations;
